import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  NORMAL_PAYMENT,
  PAYMENT_PLANS,
  PAYMENT_PLANS_CLUBS,
  PAYMENT_PLANS_ATHLETE,
  PROMO_CODE_PAYMENT,
  PAYMENT_HISTORY,
  PROMO_CODE_CHECK,
  PROMO_CODE_PAYMENT_VALIDATION,
  PAYMENT_HISTORIES,
  PAYMENT_FREE_PATH,
  INITIALIZE_PAYMENT
} from "@/utils/api-url";

export default class Payment extends Base {
  constructor(params = {}) {
    super(params);

    this.id = params["_id"] || this.Id || this.id || null;
    this.key = params["_id"] || this.Id || this.id || null;
    this.paymentExpirationDate = params['expirationDate'] || this.expirationDate || ''
    this.tablePricingPlan =
      `${params["termPlan"]} months` || `${this.termPlan}months` || "";
    this.tableAmount =
      `$${params["paidAmount"]}` || `$${this.paidAmount}` || "";
    this.paymentDate = this.paymentDate
      ? `${new Date(this.paymentDate).toLocaleDateString()} ${new Date(
          this.paymentDate
        ).toLocaleTimeString()}`
      : "";
    this.expirationDate = this.expirationDate
      ? `${new Date(this.expirationDate).toLocaleDateString()} ${new Date(
          this.expirationDate
        ).toLocaleTimeString()}`
      : "";
  }

  static getPaymentPlans(params) {
    return apiDispatcher(PAYMENT_PLANS(params));
  }

  static paypalPayment(params) {
    return apiDispatcher(PROMO_CODE_PAYMENT(params));
  }

  static paypalPaymentNormal(params) {
    return apiDispatcher(NORMAL_PAYMENT(params));
  }

  static promoCodePaymentValidation(params) {
    return apiDispatcher(PROMO_CODE_PAYMENT_VALIDATION(params));
  }

  static promoCodeCheck(params) {
    return apiDispatcher(PROMO_CODE_CHECK(params));
  }

  static createPaymentHistory(params) {
    return apiDispatcher(PAYMENT_HISTORY(params));
  }

  static paymentHistories(params) {
    return apiDispatcher(PAYMENT_HISTORIES(params));
  }

  static getPaymentPlansClub(params) {
    return apiDispatcher(PAYMENT_PLANS_CLUBS(params));
  }

  static getPaymentPlansAthlete(params) {
    return apiDispatcher(PAYMENT_PLANS_ATHLETE(params));
  }

  static freePayment(params) {
    return apiDispatcher(PAYMENT_FREE_PATH(params));
  }

  static initializePayment(params) {
    return apiDispatcher(INITIALIZE_PAYMENT(params));
  }
}
